import { createBrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import RequireMember from "./components/RequireMember";
import Portal from "./pages/Portal";
import Properties from "./pages/Properties";
import PropertyDetail from "./pages/PropertyDetail";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";

/**
 * '/' 는 두 앱을 잇는 공개 포털이다. 로그인 없이 열린다.
 * 물건 화면은 RequireMember 아래에 둔다.
 * /study/* 는 SPA 라우터가 아니라 Worker 가 낙찰로드로 프록시한다.
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Portal /> },
      { path: "login", element: <Login /> },
      {
        element: <RequireMember />,
        children: [
          { path: "properties", element: <Properties /> },
          { path: "properties/:id", element: <PropertyDetail /> },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
